module.exports = __webpack_public_path__ + "static/media/comp-button.469b616e.svg";